import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import Cards from './Cards'
import TemplateForm from './index'
import Themes from './ThemesList'
import { last } from 'lodash'
import { Hidden } from '@material-ui/core'
import Templates from 'components/Templates'
// import { template } from 'components/routes'
// import List from 'components/ListView/List'
// import { withRouter } from 'react-router-dom'

const ThemesComponent = ({ modal, taskForm }) => (
  <Fragment>
    <Hidden only={['xs', 'sm', 'md']}>
      <Themes taskForm={taskForm} modal={modal} cols={5} />
    </Hidden>
    <Hidden only={['xs', 'sm', 'lg', 'xl']}>
      <Themes taskForm={taskForm} modal={modal} cols={4} />
    </Hidden>
    <Hidden only={['md', 'lg', 'xl']}>
      <div
        style={
          modal
            ? { padding: 12, height: 'calc(100% - 60px)', overflowY: 'auto' }
            : { padding: 12 }
        }
      >
        <Themes taskForm={taskForm} cols={2} />
      </div>
    </Hidden>
  </Fragment>
)

const CardsComponent = ({ taskForm, modal }) => {
  return (
    <Fragment>
      <Hidden smDown>
        <Cards modal={modal} taskForm={taskForm} cols={taskForm ? 3 : 2} />
      </Hidden>
      <Hidden mdUp>
        <div style={{ padding: 12 }}>
          <Cards modal={modal} taskForm={taskForm} cols={taskForm ? 3 : 2} />
        </div>
      </Hidden>
    </Fragment>
  )
}

// const modifiedTemplateRoute = {
//   ...template,
// }

// const SmsTemplates = withRouter(({ taskForm, modal, history }) => {
//   return (
//     <>
//       <List history={history} {...modifiedTemplateRoute} />
//     </>
//   )
// })

export default connect(
  state => ({
    cardSelected: last(state.email.cardSelected),
    // taskStepper: state.view.stepper.task,
    templateStepper: state.view.stepper.template,
  }),
  null,
)(({ cardSelected, /* taskStepper, */ templateStepper, taskForm, modal }) => {
  if (taskForm) {
    switch (cardSelected) {
      // case 'blank':
      //   return <TemplateForm />
      case 'smsTemplates':
        return <Templates modal={modal} taskForm smsTemplates />
      case 'themes':
        return <ThemesComponent modal={modal} taskForm />
      case 'templates':
        return <Templates modal={modal} taskForm />
      default:
        return <CardsComponent modal={modal} taskForm />
    }
  }

  const cardObj = {
    smsTemplates: <Templates modal={modal} taskForm={taskForm} smsTemplates />,
    themes: <ThemesComponent modal={modal} taskForm={taskForm} />,
    templates: <Templates modal={modal} taskForm={taskForm} />,
  }
  const steps = [
    cardObj[cardSelected] || <CardsComponent modal={modal} />,
    <TemplateForm modal={modal} />,
  ]

  return steps[templateStepper]
})
